import React from "react"
import PropTypes from "prop-types"
import { Field, reduxForm } from "redux-form"
import { Checkbox } from "redux-form-material-ui"
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel"
import Hidden from "@material-ui/core/Hidden/Hidden"
import IconButton from "@material-ui/core/IconButton/IconButton"
import Typography from "@material-ui/core/Typography/Typography"
import withStyles from "@material-ui/core/styles/withStyles"
import withTheme from "@material-ui/core/styles/withTheme"
import BackIcon from "react-icons/lib/md/arrow-back"
import { translate } from "react-i18next"
import { compose } from "redux"

import styles from "./styles"
import AppicalTextField from "../../lib/views/AppicalTextField/AppicalTextField"
import Logo from "../../lib/views/Icons/Logo"
import Button from "../../lib/views/Button/Button"
import { isCurrentCompanyAppical } from "../../constants"

export const TwoFactorAuthForm = ({
    t,
    classes,
    theme,
    handleSubmit,
    submitting,
    invalid,
    handleBackButton,
}) => {
    let color = theme.palette.primary.contrastText
    let height = 142
    let width = 142
    if (isCurrentCompanyAppical) {
        color = theme.palette.primary.main
        height = 120
        width = 120
    }

    return (
        <form className={classes.form} onSubmit={handleSubmit}>
            <div className={classes.appicalLogo}>
                <Logo
                    color={color}
                    height={height}
                    width={width}
                />
            </div>
            <Typography
                variant="subtitle1"
                align="center"
                className={classes.welcomeTitle}
            >
                {t("main:two_factor_auth_code_message")}
            </Typography>

            <div className={classes.fieldWithBackButtonContainer}>
                <Hidden xsDown>
                    <IconButton
                        color="inherit"
                        className={classes.backButton}
                        onClick={handleBackButton}
                        aria-label={t("main:back")}
                    >
                        <BackIcon />
                    </IconButton>
                </Hidden>
                <Field
                    name="login_code"
                    autofocus
                    component={AppicalTextField}
                    autocorrect="off"
                    autocapitalize="none"
                    label={t("main:two_factor_auth_code")}
                    className={isCurrentCompanyAppical ? classes.input : ""}
                />
                <div className={classes.textBelow}>
                    <Typography variant="caption" color="inherit">
                        {t("main:two_factor_auth_code_check_email")}
                    </Typography>
                </div>
            </div>

            <FormControlLabel
                classes={{
                    label: classes.checkbox,
                }}
                color="inherit"
                control={(
                    <Field
                        id="disable_checked"
                        name="disable_checked"
                        component={props => (
                            <Checkbox
                                classes={{
                                    root: classes.checkbox,
                                    checked: classes.checkbox,
                                }}
                                {...props}
                            />
                        )}
                    />
                )}
                label={t("main:two_factor_auth_disable")}
            />

            <div className={classes.buttonContainer}>
                <Button type="login" disabled={invalid || submitting} loader={submitting}>
                    {t("main:login")}
                </Button>
            </div>
        </form>
    )
}


TwoFactorAuthForm.propTypes = {
    t: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    handleBackButton: PropTypes.func.isRequired,
}

TwoFactorAuthForm.defaultProps = {}

export default compose(
    reduxForm({
        form: "twoFactorAuthentication",
        destroyOnUnmount: true,
        forceUnregisterOnUnmount: true,
    }),
    translate(),
    withStyles(styles),
    withTheme(),
)(TwoFactorAuthForm)
